import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCouponApi,
  ApplyCouponApi,
} from "../../api/order-processing-api/couponApi";
import {
  cancelOrderApi,
  CreateOrderRazApi,
  getOrdersApi,
  getSingleOrdersApi,
  PlaceOrderApi,
  returnOrderApi,
  uploadCustomPhotoApi,
  uploadOrderCustomPhotoApi,
} from "../../api/order-processing-api/ordersApi";

// Async thunks for API calls
export const CreateOrderRaz = createAsyncThunk(
  "order/CreateOrderRaz",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await CreateOrderRazApi(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const PlaceOrder = createAsyncThunk(
  "order/PlaceOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await PlaceOrderApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const cancelOrder = createAsyncThunk(
  "order/cancelOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await cancelOrderApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const returnOrder = createAsyncThunk(
  "order/returnOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await returnOrderApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);


export const getOrders = createAsyncThunk(
  "order/getOrders",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getOrdersApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const getSingleOrders = createAsyncThunk(
  "order/getSingleOrders",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getSingleOrdersApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const ApplyCoupon = createAsyncThunk(
  "order/ApplyCoupon",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await ApplyCouponApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const getCoupon = createAsyncThunk(
  "order/getCoupon",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getCouponApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const uploadCustomPhoto = createAsyncThunk(
  "order/uploadCustomPhoto",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await uploadCustomPhotoApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const uploadOrderCustomPhoto = createAsyncThunk(
  "order/uploadOrderCustomPhoto",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await uploadOrderCustomPhotoApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

// Initial state

const initialState = {
  loading: false,
  appling: false,
  cancelling: false,
  orders: {},
  singleOrders: {},
  couponResponse: {},
  uploadCustomPhotoLoading: false,
  uploadCustomPhotoResponse: {},
  createOrderResponse: {},
  createOrderRazResponse: {},
  orderProcessing: false,
};

// Slice definition
const OrderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // order placed
    builder
      .addCase(CreateOrderRaz.pending, (state) => {
        state.loading = true;
        state.createOrderResponse = {};
      })
      .addCase(CreateOrderRaz.fulfilled, (state, action) => {
        state.loading = false;
        state.createOrderResponse = action.payload.response;
      })
      .addCase(CreateOrderRaz.rejected, (state) => {
        state.loading = false;
        state.createOrderResponse = {};
      });

    builder
      .addCase(PlaceOrder.pending, (state) => {
        state.orderProcessing = true;
        state.loading = true;
        state.createOrderResponse = {};
      })
      .addCase(PlaceOrder.fulfilled, (state, action) => {
        state.orderProcessing = true;
        state.loading = false;
        state.createOrderResponse = action.payload.response;
      })
      .addCase(PlaceOrder.rejected, (state) => {
        state.orderProcessing = true;
        state.loading = false;
        state.createOrderResponse = {};
      });

      builder
      .addCase(cancelOrder.pending, (state) => {
        // state.orderProcessing = true;
        state.cancelling = true;
        // state.createOrderResponse = {};
      })
      .addCase(cancelOrder.fulfilled, (state, action) => {
        state.orderProcessing = true;
        state.cancelling = false;
        state.createOrderResponse = action.payload.response;
      })
      .addCase(cancelOrder.rejected, (state) => {
        state.orderProcessing = true;
        state.cancelling = false;
        state.createOrderResponse = {};
      });

      builder
      .addCase(returnOrder.pending, (state) => {
        // state.orderProcessing = true;
        state.cancelling = true;
        // state.createOrderResponse = {};
      })
      .addCase(returnOrder.fulfilled, (state, action) => {
        state.orderProcessing = true;
        state.cancelling = false;
        state.createOrderResponse = action.payload.response;
      })
      .addCase(returnOrder.rejected, (state) => {
        state.orderProcessing = true;
        state.cancelling = false;
        state.createOrderResponse = {};
      });

    // coupon applied
    builder
      .addCase(ApplyCoupon.pending, (state) => {
        state.appling = true;
        state.couponResponse = {};
      })
      .addCase(ApplyCoupon.fulfilled, (state, action) => {
        state.appling = false;
        state.couponResponse = action.payload.response;
      })
      .addCase(ApplyCoupon.rejected, (state) => {
        state.appling = false;
        state.couponResponse = {};
      });

    builder
      .addCase(getCoupon.pending, (state) => {
        state.loading = true;
        state.couponResponse = {};
      })
      .addCase(getCoupon.fulfilled, (state, action) => {
        state.loading = false;
        state.couponResponse = action.payload.response;
      })
      .addCase(getCoupon.rejected, (state) => {
        state.loading = false;
        state.couponResponse = {};
      });

    // fetch orders
    builder
      .addCase(getOrders.pending, (state) => {
        state.orderProcessing = true;
        state.loading = true;
        state.orders = {};
      })
      .addCase(getOrders.fulfilled, (state, action) => {
        state.orderProcessing = true;
        state.loading = false;
        state.orders = action.payload.response;
      })
      .addCase(getOrders.rejected, (state) => {
        state.orderProcessing = true;
        state.loading = false;
        state.orders = {};
      });

    builder
      .addCase(getSingleOrders.pending, (state) => {
        state.orderProcessing = true;
        state.loading = true;
        state.singleOrders = {};
      })
      .addCase(getSingleOrders.fulfilled, (state, action) => {
        state.orderProcessing = true;
        state.loading = false;
        state.singleOrders = action.payload.response;
      })
      .addCase(getSingleOrders.rejected, (state) => {
        state.orderProcessing = true;
        state.loading = true;
        state.singleOrders = {};
      });

    builder
      .addCase(uploadCustomPhoto.pending, (state) => {
        state.uploadCustomPhotoLoading = true;
        state.uploadCustomPhotoResponse = {};
      })
      .addCase(uploadCustomPhoto.fulfilled, (state, action) => {
        state.uploadCustomPhotoLoading = false;
        state.uploadCustomPhotoResponse = action.payload?.response || {};
      })
      .addCase(uploadCustomPhoto.rejected, (state) => {
        state.uploadCustomPhotoLoading = false;
        state.uploadCustomPhotoResponse = {};
      });

    builder
      .addCase(uploadOrderCustomPhoto.pending, (state) => {
        state.uploadCustomPhotoLoading = true;
        state.uploadCustomPhotoResponse = {};
      })
      .addCase(uploadOrderCustomPhoto.fulfilled, (state, action) => {
        state.uploadCustomPhotoLoading = false;
        state.uploadCustomPhotoResponse = action.payload?.response || {};
      })
      .addCase(uploadOrderCustomPhoto.rejected, (state) => {
        state.uploadCustomPhotoLoading = false;
        state.uploadCustomPhotoResponse = {};
      });



  },
});

export default OrderSlice.reducer;
